import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { SettingsComponent } from './settings/settings.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { GroupsComponent } from './groups/groups.component';
import { MatChipsModule } from '@angular/material/chips';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import {MatSliderModule} from '@angular/material/slider';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import {ScrollingModule as ScrollExp} from '@angular/cdk-experimental/scrolling';
import { MatBadgeModule } from '@angular/material/badge';
import {AppCommonModule} from '../common/common.module';


@NgModule({
  declarations: [HomeComponent, SettingsComponent, GroupsComponent],
  imports: [
    CommonModule,
    ScrollingModule,
    ScrollExp,
    MatChipsModule,
    NgbRatingModule,
    MatSliderModule,
    MatSidenavModule,
    MatSlideToggleModule,
    NgxSliderModule,
    MatBadgeModule,
    AppCommonModule
  ]
})
export class MainModule { }
